module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAWCAYAAAAvg9c4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACnSURBVHgB7dUxDoJAEAXQ/2dJiIkFR+AIeANLQ6Un0BJLj+ANLO04gpSWHoUj0BiJLLtSYGIMFQvdvmbzd5JfzhCdTdaslZGklXdxvy5KOGKa6QMpeZ/LZ8jV48IKDoRU+58cL2udwJFgBr7Ul/pSXzqZ4P/DUt3Sox21T0lUral3wcAsImyEMSygGOZCwGnLDxGjm3P3lphGZbU+8Zu22SuGo6I/mh9M0SrU8Ekl3wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qr-code-3.png
// module id = DSSY
// module chunks = 1